/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteMappingElementMutationRequest,
  DeleteMappingElementMutationResponse,
} from "../types/DeleteMappingElement.ts"

export const deleteMappingElementMutationKey = () =>
  [{ url: "/v1/client-settings/delete-mapping-element" }] as const

export type DeleteMappingElementMutationKey = ReturnType<
  typeof deleteMappingElementMutationKey
>

/**
 * {@link /v1/client-settings/delete-mapping-element}
 */
export async function deleteMappingElement(
  data: DeleteMappingElementMutationRequest,
  config: Partial<RequestConfig<DeleteMappingElementMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeleteMappingElementMutationResponse,
    ResponseErrorConfig<Error>,
    DeleteMappingElementMutationRequest
  >({
    method: "DELETE",
    url: `/v1/client-settings/delete-mapping-element`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deleteMappingElementMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<DeleteMappingElementMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = deleteMappingElementMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteMappingElementMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deleteMappingElement(data, config)
    },
  })
}

/**
 * {@link /v1/client-settings/delete-mapping-element}
 */
export function useDeleteMappingElement<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteMappingElementMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeleteMappingElementMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<DeleteMappingElementMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? deleteMappingElementMutationKey()

  const baseOptions = deleteMappingElementMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteMappingElementMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteMappingElementMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteMappingElementMutationRequest },
    TContext
  >
}
